import script from "./WheelsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WheelsSection.vue?vue&type=script&setup=true&lang=js"

import "./WheelsSection.vue?vue&type=style&index=0&id=7062c4f1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7062c4f1"]])

export default __exports__